import { render, staticRenderFns } from "./titlecard.vue?vue&type=template&id=6d1160f4&scoped=true&"
import script from "./titlecard.vue?vue&type=script&lang=js&"
export * from "./titlecard.vue?vue&type=script&lang=js&"
import style0 from "./titlecard.vue?vue&type=style&index=0&id=6d1160f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1160f4",
  null
  
)

export default component.exports